import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpBookingDeadlineNotice
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Wrap {@link pkpTsoNotice} To display a TSO notice and append lead time information.
     *
     * @param {string} tsoName The name of the TSO to be shown as the headline.
     * @param {string} tsoNotice The notice of the TSO.
     * @param {string} leadTimeInfo Information regarding the lead time to be appended with a preceding horizontal line.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpBookingDeadlineNotice', pkpBookingDeadlineNotice);

    function pkpBookingDeadlineNotice() {
        return {
            restrict: 'E',
            scope: {
                tsoName: '=',
                tsoNotice: '=',
                leadTimeInfo: '='
            },
            template:
                require('app/_directives/pkp-booking-deadline-notice.directive.html')
        };
    }
})();
